import isNumber from "lodash/isNumber";

import { useStateQuery } from "@/lib/useStateQuery";

export function useProgramId() {
  const [programId, setProgramId, buildNewProgramIdUrl] = useStateQuery<
    number | undefined
  >("programId", {
    queryToValue: v => (v !== undefined && isNumber(+v) ? +v : undefined),
    valueToQuery: v => (isNumber(v) ? String(v) : undefined),
  });

  return { programId, setProgramId, buildNewProgramIdUrl };
}
